const dateFormatter = (
  date: Date,
  useTime: boolean,
  time: string,
  seperator: string,
  reverse: boolean = false,
  prefix = '',
  suffix = ''
) => {
  if (!date && !time) return '';
  if (!date && time) {
    return `${prefix}${time}${suffix}`;
  }
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  if (!reverse) {
    if (useTime)
      return `${prefix}${year}${seperator}${month.toString().padStart(2, '0')}${seperator}${day.toString().padStart(2, '0')} ${time ?? `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`}${suffix}`;
    else
      return `${prefix}${year}${seperator}${month.toString().padStart(2, '0')}${seperator}${day.toString().padStart(2, '0')}${suffix}`;
  } else {
    if (useTime)
      return `${prefix}${day.toString().padStart(2, '0')}${seperator}${month.toString().padStart(2, '0')}${seperator}${year} ${time ?? `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`}${suffix}`;
    else
      return `${prefix}${day.toString().padStart(2, '0')}${seperator}${month.toString().padStart(2, '0')}${seperator}${year}${suffix}`;
  }
};

export default dateFormatter;
